import { ApplicationVersionDto } from '@app/applicationVersions/dto';

import { useFetchLatestAppVersion } from './use-fetch-latest-app-version';

type LatestVersions = {
  isFetching: boolean;
  Windows: {
    x64?: ApplicationVersionDto;
    arm64?: ApplicationVersionDto;
  };
  macOs: {
    x64?: ApplicationVersionDto;
    arm64?: ApplicationVersionDto;
  };
  Linux: {
    x64?: ApplicationVersionDto;
    arm64?: ApplicationVersionDto;
  };
};

export const useLatestAppVersions = (): LatestVersions => {
  const {
    result: winX64,
    query: { isFetching: isFetchingWinX64 },
  } = useFetchLatestAppVersion({
    os: 'Windows',
    cpuArchitecture: 'x64',
  });
  const {
    result: winArm64,
    query: { isFetching: isFetchingWinArm64 },
  } = useFetchLatestAppVersion({
    os: 'Windows',
    cpuArchitecture: 'arm64',
  });

  const {
    result: macX64,
    query: { isFetching: isFetchingMacX64 },
  } = useFetchLatestAppVersion({
    os: 'macOs',
    cpuArchitecture: 'x64',
  });
  const {
    result: macArm64,
    query: { isFetching: isFetchingMacArm64 },
  } = useFetchLatestAppVersion({
    os: 'macOs',
    cpuArchitecture: 'arm64',
  });

  const {
    result: linuxX64,
    query: { isFetching: isFetchingLinuxX64 },
  } = useFetchLatestAppVersion({
    os: 'Linux',
    cpuArchitecture: 'x64',
  });
  const {
    result: linuxArm64,
    query: { isFetching: isFetchingLinuxArm64 },
  } = useFetchLatestAppVersion({
    os: 'Linux',
    cpuArchitecture: 'arm64',
  });

  return {
    isFetching:
      isFetchingWinX64 ||
      isFetchingWinArm64 ||
      isFetchingMacX64 ||
      isFetchingMacArm64 ||
      isFetchingLinuxX64 ||
      isFetchingLinuxArm64,
    Windows: {
      x64: winX64?.data?.items?.[0],
      arm64: winArm64?.data?.items?.[0],
    },
    macOs: {
      x64: macX64?.data?.items?.[0],
      arm64: macArm64?.data?.items?.[0],
    },
    Linux: {
      x64: linuxX64?.data?.items?.[0],
      arm64: linuxArm64?.data?.items?.[0],
    },
  };
};
